import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Headline } from '@xingternal/typography';
import { Column } from '@xingternal/xing-grid';

import { SimilarJob } from '@/components/similar-job';
import { SimilarJobFragment } from '@/graphql/generated';

import { JobRecommendationsSimilarJobFragmentWithVisibleJob } from '../../../../job-posting.types';

import * as S from './similar-jobs-sidebar-component.styles';

type Props = {
  similarJobs: {
    loading: boolean;
    data: SimilarJobFragment[];
  };
};

const isVisibleJob = (item: SimilarJobFragment): item is JobRecommendationsSimilarJobFragmentWithVisibleJob => {
  return item?.job?.__typename === 'VisibleJob';
};

const SimilarJobsSidebar: React.FC<Props> = ({ similarJobs }) => {
  const { data, loading } = similarJobs;

  const visibleJobs = data?.filter(isVisibleJob);

  return (
    <Column
      size={0}
      sizeWide={4}
      data-testid="job-posting-similar-jobs-sidebar"
      data-cy="job-posting-similar-jobs-sidebar"
    >
      <Headline size="large">
        <FormattedMessage id="JOB_POSTING_SIMILAR_JOBS_H" />
      </Headline>
      {loading ? (
        <>
          {Array(4)
            .fill(undefined)
            .map((_, i) => (
              <S.SimilarJobWrapper key={i}>
                <SimilarJob template="JobCard" isLoading />
              </S.SimilarJobWrapper>
            ))}
        </>
      ) : (
        <>
          {visibleJobs.length > 0
            ? visibleJobs.map(
                ({ job, trackingToken, position }) =>
                  job && (
                    <S.SimilarJobWrapper key={job.id}>
                      <SimilarJob
                        job={job}
                        template="JobCard"
                        trackingParam="jb_21"
                        trackingToken={trackingToken}
                        position={position}
                      />
                    </S.SimilarJobWrapper>
                  )
              )
            : null}
        </>
      )}
    </Column>
  );
};

export default SimilarJobsSidebar;
